import React from 'react';
import FilterContext from '@jetshop/core/components/Filters/FilterContext';
import Checkbox from '../../Checkbox/Checkbox';
import stripCategoryId from '@jetshop/core/components/Filters/utils/stripCategoryId';
const BoolFilters = ({ filters }) => {
    const boolFilters = filters
        ? filters.filter(filter => filter.__typename === 'BooleanFilter')
        : [];
    if (boolFilters.length < 1)
        return null;
    return (React.createElement(FilterContext.Consumer, null, ({ activeFilters, applyBoolFilter }) => boolFilters.map(filter => {
        const isSelected = activeFilters.booleanFilters.some(item => item.id === stripCategoryId(filter.id));
        return (React.createElement(Checkbox, { key: filter.id, label: filter.name, checked: isSelected, onChange: (e) => applyBoolFilter(filter.id, e.currentTarget.checked) }));
    })));
};
export default BoolFilters;
//# sourceMappingURL=BoolFilters.js.map